import { Container, Graphics } from 'pixi.js';
import { MonoBehavior } from './core/monoBehavior';
import { Layout } from './LayoutManager';
import { addToLevel } from './core/Playable2DRootContainer';
import gsap, { Power1 } from 'gsap';
import { SoundManager } from './core/soundManager';
const ANIMATION_UNIT = 0.2;
const FULL_ANIMATION = ANIMATION_UNIT * 6;
const FADE_ANIMATION = ANIMATION_UNIT * 1.6;
const ROTATION_FROM = Math.PI * 2 * -0.6;
const ROTATION_TO = Math.PI * 2 * 0.6;
let blockedColumn = 0;
export class ColumnBlockAnimation extends MonoBehavior {
    container: Container;
    mask: Graphics;
    shape: Graphics;
    loopTween: gsap.core.Tween;

    constructor(parent: Container) {
        super();
        this.container = new Container();
        this.shape = new Graphics();
        this.mask = new Graphics();
        const cardSize = Layout.getCardSize();
        this.container.position = parent.position;
        this.shape.roundRect(
            -cardSize.width / 2,
            -cardSize.height / 2,
            cardSize.width,
            cardSize.height,
            cardSize.width * 0.09
        );
        this.shape.stroke({ color: 0xffffff, width: 4 });
        this.container.zIndex = 999999;

        this.mask.moveTo(0, 0);
        this.mask.lineTo(0, cardSize.height);
        this.mask.lineTo(cardSize.width, cardSize.height * 0.6);
        this.mask.lineTo(0, 0);
        this.mask.fill({ color: 0xff44ff });
        this.container.addChild(this.shape);
        this.container.addChild(this.mask);
        addToLevel(this.container);

        this.mask.rotation = ROTATION_FROM;
        this.loopTween = gsap.to(this.mask, {
            rotation: ROTATION_TO,
            repeat: -1,
            ease: Power1.easeOut,
            duration: FULL_ANIMATION,
        });
        this.container.mask = this.mask;
        this.container.alpha = 0;
        gsap.to(this.container, { alpha: 1, duration: FADE_ANIMATION }).then(() => {
            blockedColumn = 0;
        });
        gsap.to(this.container, { alpha: 0, delay: FULL_ANIMATION - FADE_ANIMATION, duration: FADE_ANIMATION }).then(
            this.destroy
        );
        if (blockedColumn === 0) SoundManager.play('emptyColumnSFX');
        blockedColumn++;
    }
    destroy() {
        super.destroy();
        this.loopTween.kill();
        this.container.removeChildren();
        this.container.removeFromParent();
    }
    fadeOut() {
        gsap.to(this.container, { alpha: 0, duration: FADE_ANIMATION }).then(this.destroy);
    }
}
